import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import Joyride, { CallBackProps, Step } from 'react-joyride';
import { useLocation, useNavigate } from 'react-router-dom';
import { routePath } from 'config/routeMgt/routePath';
import { useTour } from './TourGuideContext';

const RECRUITER_TOUR_STEPS: Step[] = [
    {
        target: '.sidebarLink[href="/"]',
        content: 'Welcome to your recruiter dashboard! This is your central hub for managing job postings and talents.',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '.sidebarLink[href="/jobs"]',
        content: 'The "Jobs" section allows you to manage all your job postings. Let\'s explore it now!',
        placement: 'right',
        disableBeacon: true,
    },


    {
        target: ".recruiter-job-container",
        content: "Click here to create a new job posting. Let's create one now!",
        placement: "bottom",
        disableBeacon: true,
    },

    {
        target: '.sidebarLink[href="/talents"]',
        content: 'The "Talents" section shows all talents in your talent pool. Let\'s explore it!',
        placement: 'right',
        disableBeacon: true,
    },

    {
        target: '.sidebarLink[href="/folders"]',
        content: 'Organize talents into folders for better management. Let\'s check it out!',
        placement: 'right',
        disableBeacon: true,
    },
    {
        target: '[data-tour="create-folder"]',
        content: 'Create a new folder to organize your talents.',
        placement: 'bottom',
        disableBeacon: true,
    },
    {
        target: '.sidebarLink.flex.items-center.cursor-pointer', // match the div
        content: 'Smart Screen helps you analyze resumes against job descriptions. Let\'s explore it!',
        placement: 'right',
        disableBeacon: true,
    }



    // New step: Analysis Result
    // {
    //     target: '[data-tour="talent-table"]',
    //     content: 'After analysis, you\'ll see a talent table showing how well each resume matches the job requirements.',
    //     placement: 'top',
    //     disableBeacon: true,
    // },

];

export interface RecTourHandle {
    startTour: () => void;
}

export const RecruiterTourGuide = forwardRef((_, ref) => {
    const { running, activeTour, stepIndex, start, finish, setStepIndex } = useTour();
    const navigate = useNavigate();

    useImperativeHandle(ref, () => ({
        start: () => start('recruiter')
    }));

    const safeAdvance = (next: number, target?: string) => {
        // if (target && !document.querySelector(target)) {
        //     console.log(target);
        //     setStepIndex(next + 1);
        // } else {
        //     setStepIndex(next);
        // }
        setStepIndex(next);
    };

    const onCallback = (data: CallBackProps) => {
        const { index, type, action, status } = data;

        if (action === 'close') {
            finish();
            return;
        }

        if (type === 'step:after') {

            if (action === 'next') {
                const next = index + 1;

                switch (index) {
                    case 0:
                        navigate(routePath.jobs);
                        break;
                    case 1:
                        navigate('/jobs-add');
                        break;
                    case 2:
                        navigate(routePath.talents);
                        break;
                    case 3:
                        navigate(routePath.folders);
                        break;
                    case 5:
                        navigate(routePath.cvchat);
                        break;
                }

                setStepIndex(next);
            }

            if (action === 'prev') {
                const prev = index - 1;

                // Optional: handle navigation backwards too
                switch (index) {
                    case 1:
                        navigate(routePath.home);
                        break;
                    case 2:
                        navigate(routePath.jobs);
                        break;
                    case 3:
                        navigate('/jobs-add');
                        break;
                    case 4:
                        navigate(routePath.talents);
                        break;
                    case 6:
                        navigate(routePath.folders);
                        break;
                }

                setStepIndex(prev);
            }
        }

        if (status === 'finished' || status === 'skipped') {
            finish();
        }
    };

    return (
        <Joyride
            steps={RECRUITER_TOUR_STEPS}
            run={running && activeTour === 'recruiter'}
            continuous
            stepIndex={stepIndex}
            showSkipButton
            showProgress
            callback={onCallback}
            disableScrolling
            disableOverlayClose
            styles={{
                options: {
                    primaryColor: '#007bff',
                    overlayColor: 'rgba(0, 0, 0, 0.5)',
                    textColor: '#333',
                    zIndex: 10000,
                    arrowColor: '#007bff',
                    beaconSize: 40,
                },
                tooltip: {
                    padding: '16px 20px',
                    fontSize: '15px',
                    maxWidth: '350px',
                    backgroundColor: '#ffffff',
                    color: '#333',
                    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.2)',
                    borderRadius: '8px',
                },
                tooltipContent: {
                    padding: '10px 0',
                },
                buttonNext: {
                    backgroundColor: '#007bff',
                    color: '#fff',
                    borderRadius: '4px',
                    padding: '8px 16px',
                },
                buttonBack: {
                    color: '#007bff',
                }
            }}
        />
    );
});